export default "__VITE_ASSET___iERxVne__"